//jshint esversion: 6
import Barba from 'barba.js/src';

//TODO: dont remove active class if there
var timeoutCheck = null;
var timeoutCheckSec = 7000;

const header = document.getElementById('siteHeader');
const logo = header.getElementsByClassName('logo')[0];
const hamburger = header.getElementsByClassName('hamburger')[0].children[0];

function addBodyClasses() {
  setTimeout(() => $('body').addClass('is-virtual-scroll x-scroll'), 500);
}


var Homepage = Barba.BaseView.extend({
  namespace: 'home',
  onEnter: function() {
    $('#intercom-container, #intercom-frame').addClass('hidden');
  },
  onEnterCompleted: function() {
      const hasActive = ( header.className.indexOf('active') > -1) ? 'active' : '';
      header.className = this.container.getAttribute('data-header-class') + ` ${hasActive}`;
      logo.className = 'logo';
      hamburger.className = '';
      addBodyClasses();
      removeAddThis();
      $(header)
        .find('.home-link').addClass('active')
        .parent()
        .siblings()
        .children('a').removeClass('active');
  },
  onLeave: function(){
    timeoutCheck = setTimeout(() => {
      window.location.reload(true);
    }, timeoutCheckSec);
  },
  onLeaveCompleted: function() {
    $('#intercom-container, #intercom-frame').removeClass('hidden');
    if(timeoutCheck){
      clearTimeout(timeoutCheck);
    }
  }
});

var ContectUs = Barba.BaseView.extend({
  namespace: 'contact-us',
  onEnterCompleted: function() {
      const hasActive = ( header.className.indexOf('active') > -1) ? 'active' : '';
      header.className = this.container.getAttribute('data-header-class') + ` ${hasActive}`;
      logo.className = 'logo';
      hamburger.className = 'change-color';
      removeAddThis();
      $(header)
        .find('.contact-link').addClass('active')
        .parent()
        .siblings()
        .children('a').removeClass('active');
  }
});
var ProjectPage = Barba.BaseView.extend({
  namespace: 'project-page',
  onEnterCompleted: function() {
    console.log('onEnterCompleted');
    $(header).find('.tabs').remove();
      const hasActive = ( header.className.indexOf('active') > -1) ? 'active' : '';
      header.className = this.container.getAttribute('data-header-class') + ` ${hasActive}`;
      logo.className = 'logo';
      hamburger.className = '';
      removeAddThis();
      $(header)
        .find('.home-link').addClass('active')
        .parent()
        .siblings()
        .children('a').removeClass('active');
        try {
          let $video = $('.project-detail-page video');
          $video.each(function(i,vid){
            vid.autoplay = true;
            vid.muted = true;
            let src = $('source', vid).data('src');
            if(src) {
              $('source', vid).attr('src',src);
              $('source', vid).data('src', null);
            }

          });
        }catch (e) {

        }
  },
  onLeave: function() {
    $(header).find('.tabs').remove();
    timeoutCheck = setTimeout(() => {
      window.location.reload(true);
    }, timeoutCheckSec);
  },
    onLeaveCompleted: function () {
      if(timeoutCheck){
        clearTimeout(timeoutCheck);
      }
    }
});

var AboutUs = Barba.BaseView.extend({
  namespace: 'about-us',
  onEnterCompleted: function() {
      const hasActive = ( header.className.indexOf('active') > -1 ) ? 'active' : '';
      header.className = this.container.getAttribute('data-header-class') + ` ${hasActive}`;
      logo.className = 'logo';
      hamburger.className = '';
      addBodyClasses();
      removeAddThis();

      $(header)
        .find('.about-link').addClass('active')
        .parent()
        .siblings()
        .children('a').removeClass('active');

      $(header).find('.inner-wrapper')
      .find('.tabs')
      .remove()
      .end()
      .append(`
          <div class="tabs">
              <a href="#" class="active no-barba">About Us</a>
              <a href="#" class="no-barba">Meet The Team</a>
              <a href="#" class="no-barba">Our Clients</a>
          </div>
      `);
  },
  onLeave: function() {
    $(header).find('.tabs').remove();
  }
});

var Services = Barba.BaseView.extend({
  namespace: 'services',
  onEnterCompleted: function() {
      const hasActive = ( header.className.indexOf('active') > -1) ? 'active' : '';
      header.className = this.container.getAttribute('data-header-class') + ` ${hasActive}`;
      logo.className = 'logo';
      hamburger.className = '';
      addBodyClasses();
      removeAddThis();

      $(header)
        .find('.services-link').addClass('active')
        .parent()
        .siblings()
        .children('a').removeClass('active');
  }
});

var WorkPage = Barba.BaseView.extend({
  namespace: 'work-page',
  onEnterCompleted: function() {
      const hasActive = ( header.className.indexOf('active') > -1) ? 'active' : '';
      header.className = this.container.getAttribute('data-header-class') + ` ${hasActive}`;
      logo.className = 'logo';
      hamburger.className = '';
      addBodyClasses();
      removeAddThis();

      $(header)
        .find('li a.active').removeClass('active');
  }
});

function removeAddThis() {
  $('#at4-share').remove();
}

// Don't forget to init the view!
Homepage.init();
ContectUs.init();
ProjectPage.init();
AboutUs.init();
Services.init();
WorkPage.init();


// WEBPACK FOOTER //
// ./app/components/barbaViews.js